<template>
  <div class="container" @click="onClick">
    <div class="label">{{ props.name || '—' }}</div>
    <div class="txt" :class="{ 'line-clamp': !hovered }">{{ props.description ||
      '—' }}</div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 dātma, inc™
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

import { defineEmits, defineProps, ref } from 'vue'

const emit = defineEmits(['openDetailsModal'])
const hovered = ref(false)

const props = defineProps({
  name: String,
  description: String,
})

const onClick = () => {
  emit('openDetailsModal', props.name, props.description, 'Treatment')
}

</script>

<style lang="scss" scoped>
.container {
  transition: all linear 200ms;
  display: flex;
  width: calc(210px - 2vw);
  min-height: calc(130px - 2vh);
  max-height: 130px;
  padding: 12.96px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 9.72px;
  background: #F7F9FB;
  justify-content: flex-start;
  align-items: flex-start;
  text-overflow: ellipsis;
  overflow: hidden;

  cursor: pointer;

  &:hover {
    background: var(--Grey200);
  }

  &:hover>.txt {
    color: var(--Black);
  }

  &:hover>.label {
    font-weight: 600;
  }
}

.label {
  display: flex;
  height: 16.2px;
  flex-direction: column;
  justify-content: flex-start;
  align-self: stretch;
  color: var(--Black);
  text-overflow: ellipsis;
  font-size: 11.34px;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.081px;
  text-align: left;
  margin-bottom: 1px;
}

.txt {
  flex: 1 0 0;
  height: 1px;
  align-self: stretch;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.40);
  text-overflow: ellipsis;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.162px;
  text-align: left;
}

.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
}
</style>
